<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="save">
                    <div class="card">
                        <div class="card-header">
                            <i class="fas fa-phone"></i> Central Atendimento
                        </div>
                        <div class="card-block form form-horizontal">
                            <div class="form-group row">
                              <div
                                  class="col-md-4"
                                  :class="{ 'dropdown-has-error': $v.model.id_pais.$error }"
                              >
                                  <label>País*</label>
                                  <select-api
                                      v-model="model.id_pais"
                                      :endpoint="'/pais/pesquisa'"
                                      :opt-text="'nome'"
                                      :select-option="true"
                                  ></select-api>
                              </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>Telefone</label>
                                    <input
                                        type="text"
                                        maxlength="20"
                                        class="form-control"
                                        v-model="model.telefone"
                                    />
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-12">
                                    <label>Conteúdo</label>
                                    <vue-editor
                                        id="editor"
                                        v-model="model.conteudo"
                                    ></vue-editor>
                                </div>
                            </div>
                        </div>

                        <div class="card-footer text-right">
                            <router-link
                                :to="{ name: 'list-center' }"
                                class="btn btn-link"
                            >Cancelar</router-link>
                            <button type="submit" class="btn btn-primary">Salvar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Facade from "../../facade/facade";
const facade = new Facade();
import {
    required,
    minLength,
    maxLength,
    withParams,
    email
} from "vuelidate/lib/validators";
import {
    isNotUndefinedOrNullOrEmptyOrZero,
    isUndefinedOrNullOrEmpty
} from "@/services/string";
import SelectApi from "../../components/Input/SelectApi";

export default {
    components: {
        SelectApi
    },
    data() {
        return {
            model: {
                id: null,
                telefone: "",
                conteudo: "",
                id_pais: ''
            }
        };
    },
    validations() {
        let vm = this;

        return {
            model: {
                id_pais: {
                  required,
                  isNotUndefinedOrNullOrEmptyOrZero
                }
            }
        };
    },
    methods: {
        async save() {
            let vm = this;
            if (this.$v.model.$invalid) {
                this.$v.model.$touch();
                this.$notify.warning(
                    "Atenção!",
                    "Verifique se todos os campos estão preenchidos corretamente."
                );
                return;
            }

            this.$loading.show(true);

            try {
                if (vm.model.id) {
                    await facade.updateCenter(vm.model, vm.model.id);
                    this.$router.push({ name: "list-center" });
                } else {
                    await facade.createCenter(vm.model);
                    this.$router.push({ name: "list-center" });
                }

                this.$loading.show(false);
            } catch (e) {
                e.forEach(item => {
                    this.$notify.error(item.field, item.message);
                });
                this.$loading.show(false);
            }
        },
        throwError(e) {
            this.$notify.error("Erro!", e);
        },
        setData(model) {
            let vm = this;

            if (model !== undefined && model !== null) {
                vm.model = model;
                vm.corObjeto = vm.model.cor;
            }
        }
    },
    async beforeRouteEnter(to, from, next) {
        let center = null;

        if (to.params.id) {
            center = (await facade.getCenter(to.params.id)).data.data;
        }

        next(vm => vm.setData(center));
    }
};
</script>



// WEBPACK FOOTER //
// Form.vue?21c42a57